export default {
      id: "microphone-crossed-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "sprite.svg#microphone-crossed-usage",
      toString: function () {
        return this.url;
      }
    }